export enum EsfEntities{
    Awp,
    Egp
}